<div class="sidebar-account-info-container" *ngIf="generalSettingsData" [ngClass]="{ opened: opened, 'student-portal' : generalSettingsData.userDetails.sessionSiteViewType === 1 }">
  <div class="account-info-top-section" (click)="opened = !opened">
    <div class="account-img">
      <img
        src="{{ generalSettingsData.userDetails.studentPicture }}"
        width="46"
        height="46"
        alt="avatar"
      />
    </div>

    <div class="account-info">
      <div class="info-label">
        {{ generalSettingsData.portalHoursRangeForPeriodTime }}
      </div>
      <span class="account-settings-button" >
        {{ generalSettingsData.userDetails.firstName}} {{ generalSettingsData.userDetails.lastName }}
        <mat-icon [svgIcon]="'arrow-down'" class="square-icon dropdown-arrow"></mat-icon>
      </span>
    </div>
  </div>
  <div class="account-settings-section" [@openClose]="opened ? 'opened' : 'closed'">
    <a
      class="account-info-button mat-mdc-menu-item"
      [href]="generalSettingsData.portalGeneralSettingsData.accountSettingsLink.url"
      [target]="generalSettingsData.portalGeneralSettingsData.accountSettingsLink.target">
      <mat-icon
        *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsProfileSettingsIconUrl"
        [svgIcon]="generalSettingsData.portalGeneralSettingsData.accountSettingsProfileSettingsIconUrl"
        class="account-info-button-icon"
      ></mat-icon>
      {{generalSettingsData.portalGeneralSettingsData.accountSettingsLink.title}}
    </a>
    <ng-container *ngIf="generalSettingsData.userDetails.userType === 0 || generalSettingsData.userDetails.userType === 2">
      <button 
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 1"
        (click)="changeSessionView('StaffMember')" mat-menu-item
        class="account-info-button switch-session-type">
         <mat-icon
            *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeMobileIconUrl"
            [svgIcon]="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeMobileIconUrl"
            class="account-info-button-icon"
          ></mat-icon>
        {{ generalSettingsData.portalGeneralSettingsData.portalMenuStaffTitle }}
      </button>
      <button 
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 2"
        (click)="changeSessionView('Student')" mat-menu-item
        class="account-info-button switch-session-type">
        <mat-icon
          *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeMobileIconUrl"
          [svgIcon]="generalSettingsData.portalGeneralSettingsData.accountSettingsChangeSiteTypeMobileIconUrl"
          class="account-info-button-icon"
        ></mat-icon>
        {{
          generalSettingsData.portalGeneralSettingsData.portalMenuStudentTitle
        }}
      </button>

      <button
        (click)="openAccountSettingsPopup()" mat-menu-item
        class="account-info-button"
        *ngIf="generalSettingsData.userDetails.sessionSiteViewType === 1">
        <mat-icon
          *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsOpenSettingsPopupMobileIconUrl"
          [svgIcon]="generalSettingsData.portalGeneralSettingsData.accountSettingsOpenSettingsPopupMobileIconUrl"
          class="account-info-button-icon"
        ></mat-icon>
        {{
          generalSettingsData.portalGeneralSettingsData.accountSettingsOpenSettingsPopupText
        }}
      </button>
    </ng-container>

    <button
      (click)="onLogout()" mat-menu-item
      class="account-info-button">
      <mat-icon
        *ngIf="generalSettingsData.portalGeneralSettingsData.accountSettingsLogoutMobileIconUrl"
        [svgIcon]="generalSettingsData.portalGeneralSettingsData.accountSettingsLogoutMobileIconUrl"
        class="account-info-button-icon"
      ></mat-icon>
      {{
        generalSettingsData.portalGeneralSettingsData.logoutLinkText
      }}
    </button>
  </div>
</div>
